export function fractionToPercent(fraction, precision) {
  return (fraction * 100).toLocaleString(undefined, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
}

export function splitAtDecimalPoint(number, precision) {
  const roundingFactor = Math.pow(10, precision);
  const roundedNumber = Math.round(number * roundingFactor) / roundingFactor;
  const int = Math.floor(roundedNumber);
  const decimals = Math.round((roundedNumber - int) * Math.pow(10, precision));
  return [int, decimals];
}
